import { uiActions } from "./ui-slice";
import axios from 'axios'
// import '../utils/axios-interceptor'

export const getNewToken = (url_data, token) => {
	return async (dispatch) => {
		// dispatch(uiActions.showLoadingSpinner(1));

		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const responseData = await fetchData();
			dispatch(uiActions.updateToken(responseData));
			// dispatch(uiActions.hideLoadingSpinner(1));
		} catch (error) {
			console.log(error);
		}
	};
};

export const refreshToken = (url_data, autentication) => {
	return async (dispatch) => {
		
		const tokenObject = JSON.stringify({
			jwtToken: autentication.token,
			refreshToken: autentication.refreshToken,
		})

		// console.log(tokenObject)

		const fetchData = async () => {
			const response = await fetch(url_data, {
				method: "POST",
				headers: {
					'Content-Type': 'application/json'
				},
				body: tokenObject,
			})
			
			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.json();

			return data;
		};

		try {
			const responseData = await fetchData();
			dispatch(uiActions.updateToken(responseData));
		} catch (error) {
			console.log(error);
		}
	};
};

export const getUserData = (url_data, token) => {
	return async (dispatch) => {
		console.log("getUserData", url_data, token)
		// dispatch(uiActions.showLoadingSpinner(1));

		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			// console.log(response)

			const data = await response.data;

			return data;
		};

		try {
			const responseData = await fetchData();
			console.log("getUserData response", responseData)
			dispatch(uiActions.updateUserData(responseData));
			// dispatch(uiActions.hideLoadingSpinner(1));
		} catch (error) {
			console.log(error);
		}
	};
};

export const getUserPicture = (url_data, token) => {
	return async (dispatch) => {
		console.log("getUserPicture", url_data, token)
		// dispatch(uiActions.showLoadingSpinner(1));

		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			// console.log("getUserPicture RESPONSE", response)

			const data = await response.data;

			return data;
		};

		try {
			const responseData = await fetchData();
			dispatch(uiActions.updateUserPicture(responseData));
			// dispatch(uiActions.hideLoadingSpinner(1));
		} catch (error) {
			console.log(error);
		}
	};
};

export const logout = (url_data, token) => {
	return async (dispatch) => {
		// dispatch(uiActions.showLoadingSpinner(1));

		console.log("logout token", token)

		const fetchData = async () => {
			const response = await axios.post(url_data, {}, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response;

			return data;
		};

		try {
			const responseData = await fetchData();
			console.log("logout", responseData)

			const url = window.location.href;
			const domain = url.split(/[/?#]/)[0];
			window.location.href = `${domain}/auth/home`;			
		} catch (error) {
			console.log(error);
		}
	};
};